import gql from 'graphql-tag'

export const FIXTURE_SAMPLING_HISTORY = gql`
  query fixtureSamplingHistory($fixtureId: Int!, $accountId: Int!) {
    fixtureSamplingHistory(fixtureId: $fixtureId, accountId: $accountId) {
      fixtureId
      fixtureType
      fixtureLocation
      resultValue
      sampleLimit
      unitOfMeasure
      remediationAction
      collectedOn
    }
  }
`
